import { Theme, TypographyVariantsOptions } from '@mui/material/styles';

export default function createTypography(theme: Theme): TypographyVariantsOptions {
  const pxToRem = theme.typography.pxToRem;
  const fontFamily = ['Inter', 'sans-serif'].join(',');

  return {
    fontFamily,
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 600,
    h1: {
      fontFamily,
      fontSize: pxToRem(24),
      fontWeight: 600,
      // Responsive sizing for mobile
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(20),
      },
    },
    h2: {
      fontFamily,
      fontSize: pxToRem(20),
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(18),
      },
    },
    h3: {
      fontFamily,
      fontSize: pxToRem(18),
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(16),
      },
    },
    h4: {
      fontFamily,
      fontSize: pxToRem(16),
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(15),
      },
    },
    subtitle1: {
      fontFamily,
      fontSize: pxToRem(16),
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(15),
      },
    },
    subtitle2: {
      fontFamily,
      fontSize: pxToRem(14),
      fontWeight: 600,
    },
    body1: {
      fontFamily,
      fontSize: pxToRem(16),
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(15),
      },
    },
    body2: {
      fontFamily,
      fontSize: pxToRem(14),
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(13),
      },
    },
    caption: {
      fontFamily,
      fontSize: pxToRem(13),
      fontWeight: 400,
      [theme.breakpoints.down('sm')]: {
        fontSize: pxToRem(12),
      },
    },
    overline: {
      fontFamily,
      fontSize: pxToRem(12),
      fontWeight: 400,
      textTransform: 'none',
    },
    button: {
      fontFamily,
      fontSize: '1rem',
      fontWeight: 600,
      textTransform: 'capitalize',
    },
  };
}
